import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
  NextPageWithLayout,
} from "next";
import loadNamespaces from "next-translate/loadNamespaces";
import React, { ReactElement } from "react";
import WithReactQueryLayout from "faqSrc/components/layout/AppLayout/WithReactQueryLayout";
import TemplateQuestionTopic from "faqSrc/components/templates/questions/post/topic";
import { pagesPath } from "faqSrc/lib/$path";

// Question Topic submission screen
const PageQuestionsPostTopic: NextPageWithLayout<
  InferGetServerSidePropsType<typeof getServerSideProps>
> = ({ refererUrl }) => (
  <TemplateQuestionTopic refererUrl={refererUrl ?? undefined} />
);

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  return {
    props: {
      refererUrl: context.req.headers.referer ?? null,
      ...(await loadNamespaces({
        locale: context.locale,
        pathname: pagesPath.questions.post.topic.$url().pathname,
      })),
    },
  };
};

PageQuestionsPostTopic.getLayout = function getLayout(page: ReactElement) {
  return <WithReactQueryLayout>{page}</WithReactQueryLayout>;
};

export default PageQuestionsPostTopic;
